import React from 'react';
import ChatRoom from '../Chat';
import RoomConfiguration from './modules/ContentClassRoom/modules/RoomConfigurations';
import useCourse from './hook/courseHook';
import ContentClassRoom from './modules/ContentClassRoom';
import CourseSelection from './modules/CourseSelection';
import SidebarClassroom from './modules/SidebarClassroom';
import { ContentContainer } from './styles';
import { useAuth } from 'src/hooks/Auth';
const CourseClassroom: React.FC<Record<string, any>> = () => {

    const courseHook = useCourse();
    const { currentView, ready, content, course, notPaid } = courseHook;


    if (notPaid) {
        return <div className='full-width column' style={{ minHeight: '100vh' }}>
            <div className='row full-width'>
                <a href="/app/evento/tickets-dashboard"><button className='greenButton2'>Gerenciar ingressos</button></a>
            </div>

            <h2 style={{ fontSize: '24px', textAlign: 'center' }}>Evento exclusivo <br />Verifique o status de confirmação da sua inscrição</h2></div>
    }


    if (!ready) {
        return <div className='full-width row' style={{ minHeight: '100vh' }}><h2>Carregando...</h2></div>
    }

    if (currentView === 'list') {
        return <div className='column full-width' style={{ alignItems: 'center', flex: 1, background: 'rgba(0,0,150,0.5)', position: 'relative' }}>
            <div className='pattern' />
            <div className='row full-width'>
                <a href="/app/evento/tickets-dashboard"><button className='greenButton2'>Gerenciar ingressos</button></a>
            </div>
            <CourseSelection courseHook={courseHook} />

        </div>
    }
    if (currentView === 'course' || currentView === 'content') {

        return <>
            <RoomConfiguration content={content} courseHook={courseHook} />

            <ContentContainer style={{ flex: 1, background: 'rgba(0,0,150,0.5)', position: 'relative' }}>
                <div className='pattern' />


                {/* <SidebarClassroom courseHook={courseHook} /> */}



                <ContentClassRoom courseHook={courseHook} />

                <div className='column pad' style={{ display: course?.type === 'live' ? 'flex' : 'none' }} >

                    <ChatRoom key={`${content._id}`} slides={content?.slides || []}
                        room_name={content?.title || ''} poster_id={content?.poster_id}
                        id={content._id}
                    />
                </div>

            </ContentContainer>
        </>

    }

    return <></>

}

export default CourseClassroom;